// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Kg2Y","list":"styles_list__1kpzU"};